import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Refetch flags — flipped by WebSocket events / push handlers to nudge
 * components into re-fetching their RTK Query data. Mirrors
 * mobile-app/src/store/refetch.state.ts.
 */
export interface RefetchState {
  chat: boolean;
  bottombar: boolean;
}

const initialState: RefetchState = {
  chat: false,
  bottombar: false,
};

const refetchSlice = createSlice({
  name: 'refetch',
  initialState,
  reducers: {
    setRefetchChat: (state, action: PayloadAction<boolean>) => {
      state.chat = action.payload;
    },
    setRefetchBottombar: (state, action: PayloadAction<boolean>) => {
      state.bottombar = action.payload;
    },
    clear: () => initialState,
  },
});

export const { setRefetchChat, setRefetchBottombar, clear: clearRefetch } = refetchSlice.actions;
export default refetchSlice.reducer;
